import React from "react";
import { Button } from "react-bootstrap";

interface IDemandTopBar {
  setHideArchive: React.Dispatch<React.SetStateAction<boolean>>;
  hideArchive: boolean;
  title: string
}

export const DemandTopBar = ({title, hideArchive, setHideArchive}: IDemandTopBar) => {  
  return (
    <div style={{ display: "flex", flexDirection: "row", margin: "auto" }}>
      <div className="mr-auto" style={{ marginRight: "auto", marginLeft: "8px", fontFamily: "SF Pro Display", fontWeight: "bold", fontSize: "24px", }} >
        {title}
      </div>
      <Button variant="link" className="ml-auto" style={{ textDecorationLine: "underline", color: "#000000" }} onClick={() => setHideArchive(!hideArchive)}>
        {hideArchive ? "Показать архивные" : "Скрыть архивные"}
      </Button>
    </div>
  );
};
